// Company data
export const CompanyName = 'Mistress MD';
export const CompanyPhoneNumber = '07576183184';
export const ContactEmailAddress = 'wildthoughts82@gmail.com';
export const DirectorName = 'Mistress MD';
export const LocationCity = 'Oldbury, West Midlands';
export const LocationCountry = 'United Kingdom';

// Address Constants
export const AddressLine3 = 'Oldbury';
export const AddressLine4 = 'WR10, United Kingdom';
export const PostalCode = 'WR10';

export const CompanyTagLine = `Experience True Dominance in ${LocationCity}`;
export const MainTitle = 'Elite Dominatrix, Fetish Specialist and Wrestling Empress!';
export const SubtitleMain = 'Power, Control, and Ultimate Submission!';
export const SubtitleSecondary = `How can ${CompanyName} push your limits?`;
// Keep in sync with the description in public/index.html
export const HomePageDescription = `${CompanyName}: Elite Dominatrix specializing in BDSM, sploshing, and wrestling sessions. Indulge in unforgettable experiences with a true professional.`;

export const KeywordsPages =
  'Mistress MD, Dominatrix, BDSM, Femdom, professional dominatrix, dungeon, fetish, submission, wrestling, sploshing, fetish wrestling, messy play, Mistress sessions, findom, latex dominatrix, pegging, UK dominatrix';

// Pages
export const HOME_PAGE_URL = '/';
export const ABOUT_PAGE_URL = '/about';
export const LINKS_PAGE_URL = '/links';
export const CLIPS_FANSITES_PAGE_URL = '/clips-fansites';
export const SERVICES_PAGE_URL = '/services';
export const GALLERY_PAGE_URL = '/gallery';
export const BLOG_PAGE_URL = '/blog';

// Subpages for main services
export const DOMINATION_PAGE_URL = '/services/domination';
export const WRESTLING_PAGE_URL = '/services/wrestling';
export const SPLOSHING_PAGE_URL = '/services/sploshing';

// General routes
export const ADMIN_PAGE_URL = '/admin';
export const POLICIES_PAGE_URL = '/user-agreements'; 
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// Social & External Links
export const ADULTWORK_URL = 'https://www.adultwork.com/NytNurse+MD%5FUK';
export const MINTSTARS_URL = 'https://app.mintstars.com/mistressmd';
export const CLIPS4SALE_URL = 'https://t.clips4sale.com/z/s/138941?source=studioshare';
export const SUBMISSIONSUITE_URL = 'http://submissionsuite.co.uk';
export const BADKITY_URL = 'https://www.badkity.com/profile/mistressmd-united-kingdom-203';
export const DOMMELINK_URL = 'https://www.dommelink.com/mistressmd';
export const DOMMELINE_URL = 'https://www.dommeline.co.uk/profil/mistress-md/';
export const ALLMYLINKS_URL = 'https://allmylinks.com/mistressmd1';
export const BLUESKY_URL = 'https://bsky.app/profile/mistressmd.bsky.social';
// Real profiles, listed as sameAs in structured data
export const SOCIAL_PROFILE_URLS = [MINTSTARS_URL, ADULTWORK_URL, BLUESKY_URL, ALLMYLINKS_URL];

// Gift & Tribute Links
export const GIFT_CARD_EMAIL = 'wildthoughts82@gmail.com';
export const MINTPAY_URL = 'https://mintpay.mintstars.com/mistressmd';
export const THRONE_WISHLIST_URL = 'https://throne.com/mistressmd';
export const ADULTWORK_WISHLIST_URL = 'https://refer.adultwork.com/?R=4080313&T=UserWishlists%2Easp%3FUserID%3D4080313';

// URL
export const FULL_BUSINESS_URL = 'https://www.mistress-md.com';
export const SHORT_BUSINESS_URL = 'mistress-md.com';
export const DISPLAY_BUSINESS_URL = 'www.mistress-md.com';
export const SHARE_IMAGE_URL = `${FULL_BUSINESS_URL}/brand/share-preview.jpg`;

// API
export const LOGIN_API = '/login';
export const GET_LOGGED_IN_USER_API = '/users/user/get-logged-in-user'; // userId
export const REGISTER_API = '/users/register';
export const RESET_PASSWORD_API = '/users/user/reset-password'; // userId
// Blog Api
export const GET_BLOG_POSTS_API = '/blog/get-all-blog-posts';
export const GET_BLOG_POST_BY_TITLE_API = '/blog/get-all-blog-posts';

// Bot Data
export const BotName = 'Jerry';

// Social Media Services
export const FACEBOOK_SERVICE = 'facebook';
export const INSTAGRAM_SERVICE = 'instagram';
export const GOOGLE_SERVICE = 'google';
export const GITHUB_SERVICE = 'github';
export const APPLE_SERVICE = 'apple';
export const X_SERVICE = 'x';

// Social Media URLs
export const FACEBOOK_URL = 'https://facebook.com/';
export const INSTAGRAM_URL = 'https://instagram.com/';
export const GOOGLE_URL = 'https://google.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';

export const FACEBOOK_NAME = 'mistressmd';
export const INSTAGRAM_NAME = 'mistressmd';
export const LINKEDIN_NAME = 'mistressmd';

